const shared = {
  HEADER_HEIGHT_S: 64,
  HEADER_HEIGHT_D: 77,

  S_LAPTOP: 1224,
  LAPTOP: 1365,
  LARGELAPTOP: 1600,
  DEKSTOP: 1920,
  S_SEARCH: 60,
  L_SEARCH: 118,

  MOBILE_STICKY_HEIGHT: 900,
  MOBILE_STICKY_HEIGHT_SMALL: 330,

  MTARGETSCALE: 0.34,
  LTARGETSCALE: 0.4,
  SSCROLLPADDING: 100,
  MSCROLLPADDING: 400,
  MHEADERSCROLLTARGETVALUE: 365,
  LHEADERSCROLLTARGETVALUE: 425,
  SHEADERSCROLLTARGETVALUE: 250,
  MTRANSLATEPLUS: 65,
  LTRANSLAPTEPLUS: 85,
  BANNERHEIGHT: 600,
}

export default shared
